import {Button, Grid, TextField, Stack} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectCultura from "../../../../../../../components/SelectsSimpleApiQuery/SelectCultura";
import SelectAgrotoxico from "../../../../../../../components/SelectsSimpleApiQuery/SelectAgrotoxico";

export default function Stepper01() {
    const { control, getValues, handleSubmit } = useFormContext();
    const handleNext = getValues("funcoesAux.onNext");

    const handleNextStep = () => {
        handleNext();
    };

    return (
        <Grid container spacing={2}>

            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="formulacao"
                    control={control}
                    rules={{ required: "Formulação é obrigatório" }}
                    render={({ field, fieldState: { error, invalid }} ) => (
                        <TextField
                            {...field}
                            label="Formulação"
                            type="string"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="concentracao"
                    control={control}
                    rules={{ required: "Concentração é obrigatório" }}
                    render={({ field, fieldState: { error, invalid }}) => (
                        <TextField
                            {...field}
                            label="Concentração"
                            type="string"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="cultura"
                    control={control}
                    rules={{ required: "Cultura é obrigatório" }}
                    render={({ field, fieldState: {invalid}  }) => (

                        <SelectCultura
                            required
                            error={invalid}
                            unique_select={true}
                            value={field.value ?? []}
                            onChange={field.onChange}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="agrotoxico"
                    control={control}
                    rules={{ required: "Agrotóxico é obrigatório" }}
                    render={({ field, fieldState: {invalid}  }) => (

                        <SelectAgrotoxico
                            required
                            error={invalid}
                            unique_select={true}
                            value={field.value ?? []}
                            onChange={field.onChange}
                        />
                    )}
                />
            </Grid>

            <Stack direction="row" justifyContent="flex-start" mt={2}>
                <Button variant="contained" onClick={handleSubmit(handleNextStep)}>
                    Avançar
                </Button>
            </Stack>
        </Grid>
    );
}